import UserPrepaidCardApi from '@apis/prepaid/UserPrepaidCardApi';
import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { useFlow } from '@router/stackflow';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import useUserPrepaidCards from '../../../hooks/useUserPrepaidCards';

function useDeleteAllPrepaidCards() {
  const { prepaidCards } = useUserPrepaidCards();
  const queryClient = useQueryClient();
  const toast = useToast();
  const { pop } = useFlow();
  const { mutate } = useMutation({
    mutationFn: UserPrepaidCardApi.deleteAllPrepaidCards,
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: queries.userPrepaidCard._def });
      pop();
      toast.info('선불카드가 삭제되었습니다.');
    },
    onError(e: AxiosError<ErrorResponse>) {
      toast.error(e.response?.data.message || '선불카드 삭제에 실패했습니다.');
    },
  });
  const handleDeleteAllPrepaidCards = () => {
    if (!prepaidCards || prepaidCards?.length === 0) {
      toast.info('삭제할 선불카드가 없습니다.');
      return;
    }

    const totalBalance = prepaidCards
      .map((card) => card.balance)
      .reduce((acc, cur) => acc + cur, 0);

    if (totalBalance !== 0) {
      toast.error('선불카드 잔액이 남아있습니다. 잔액을 모두 사용한 후 삭제해주세요.');
      return;
    }
    mutate();
  };
  return { handleDeleteAllPrepaidCards };
}

export default useDeleteAllPrepaidCards;
